import React from 'react'
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer"
import Navbar from '../../../../components/Navbar/Navbar';
import { developerganga ,Headers} from '../../../../data/projects/ganga/data';  // Adjust the path based on your file structure
import DevelopersPageComponent from '../../../../components/body/topDevelopersComponents/developerspageComponent/developersPageComponent'
import DeveloperPageHeaderComponent from '../../../../components/body/topDevelopersComponents/developerspageComponent/DeveloperPageHeaderComponent';
import { groupProperties } from "../../../../components/body/topDevelopersComponents/filterproperty";

const Gangadeveloper = () => {
    const isState = 1; 
    const properties = developerganga?.properties || [];
    const groupedProperties = groupProperties(properties, isState);
    return (
      <div>
        <Navbar />
        <DeveloperPageHeaderComponent Headers={Headers} />
        <div className="">
          {Object.entries(groupedProperties).map(([key, properties]) => (
            <div key={key}>
            
              <DevelopersPageComponent
                developersData={properties}
                heading={`${properties[0]?.developer} Properties in ${key}`}
              />
            </div>
          ))}
        </div>
  
        <Main_Footer />
      </div>
    );
}

export default Gangadeveloper